import { render, staticRenderFns } from "./Legal_success.vue?vue&type=template&id=0be3a4a5&scoped=true"
import script from "./Legal_success.vue?vue&type=script&lang=js"
export * from "./Legal_success.vue?vue&type=script&lang=js"
import style0 from "./Legal_success.vue?vue&type=style&index=0&id=0be3a4a5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be3a4a5",
  null
  
)

export default component.exports